<template>
  <div class="rc-member-run" :class="[component.properties.sortType==='toTop'&& 'to-top']">
    <el-form-item class="rc-member-content"
                  :class="[component.properties.sortType==='toTop'&& 'to-top',component.properties.sortType==='hidden'&& 'hidden']"
                  ref="rcMember"
                  :label="labelParameter.labelName" :prop="getProp" :rules="rules"
                  :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <label class="selected">
        <span class="choiceMember" :class="{'readonly':disabled || component.properties.readonly}"
              @click="openDialog">请选择</span>
        <span class="memberName" :title="getValue()">
          {{getValue()}}
        </span>
      </label>
    </el-form-item>
    <el-dialog title="成员选择"
               :visible.sync="memberDialog.dialogVisible"
               custom-class="member-dialog"
               center append-to-body
               :before-close="dialogClose"
               :close-on-click-modal="false"
               width="508px">
      <div class="member-dialog-content">
        <div class="left">
          <div class="search">
            <el-input prefix-icon="el-icon-search"
                      v-model="memberDialog.filterText"
                      placeholder="搜索人员">
            </el-input>
          </div>
          <el-tree
            :data="data" node-key="id" ref="tree"
            :filter-node-method="filterNode"
            :check-on-click-node="true"
            :default-expanded-keys="firstLevelId"
            icon-class="el-icon-folder-add"
            :check-strictly="true"
            @node-click="checkChange">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span><i :class="node.icon"></i>{{ data.name }}</span>
          <template v-if="data.type==='user'">
               <i v-show="data.flag===true" class="el-icon-check"></i>
          </template>
        </span>
          </el-tree>
        </div>
        <div class="right">
          <div class="title"><span>已选择的成员</span></div>
          <div class="person">
            <p v-for="(selected, index) in memberDialog.selectedList" :key="index">
              <span>{{selected[defaultProps.label]}}</span>
              <i class="el-icon-error remove-select" @click="removeSeleted(selected.id)"></i>
            </p>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="memberConfirm">确 定</el-button>
        <el-button @click="dialogClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { componentMixin, inputMixin, calculationMixin, defaultValueMixin } from './mixins'

export default {
  name: 'rc-member',
  mixins: [componentMixin, inputMixin, calculationMixin, defaultValueMixin],
  props: ['component', 'value', 'disabled', 'labelParameter'],
  data () {
    return {
      memberDialog: {
        dialogVisible: false,
        filterText: '',
        selectedList: []
      },
      radio: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      memberSelectedList: [],
      memberData: [],
      initData: [],
      firstLevelId: []
    }
  },
  created () {
    this.getPrincipal()
  },
  methods: {
    openDialog () {
      if (!this.disabled && !this.component.properties.readonly) {
        this.memberDialog.selectedList = JSON.parse(JSON.stringify(this.memberSelectedList))
        this.data = JSON.parse(JSON.stringify(this.memberData))
        this.memberDialog.filterText = ''
        this.memberDialog.dialogVisible = true
      }
    },
    checkChange (data, checked) {
      if (data.type === 'user') {
        data.flag = !data.flag
        let index = this.memberDialog.selectedList.findIndex(m => m.id === data.id)
        if (index === -1) {
          this.memberDialog.selectedList.push({'id': data.id, 'name': data.name, 'type': data.type})
        } else {
          this.memberDialog.selectedList.splice(index, 1)
        }
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    removeSeleted (id) {
      let index = this.memberDialog.selectedList.findIndex(m => m.id === id)
      if (index > -1) {
        this.memberDialog.selectedList.splice(index, 1)
        // 树中选中的勾选的值的取消
        this.$refs.tree.setCheckedKeys([])
        let checkedKeys = []
        this.memberDialog.selectedList.forEach(m => {
          checkedKeys.push(m.id)
        })
        this.$refs.tree.setCheckedKeys(checkedKeys)
        this.removeNode(id, this.data)
      }
    },
    memberConfirm () {
      this.memberSelectedList = JSON.parse(JSON.stringify(this.memberDialog.selectedList))
      this.memberData = JSON.parse(JSON.stringify(this.data))
      this.update(this.getValue())
      this.dialogClose()
      // 触发值改变事件
      this.$nextTick(() => {
        this.$refs.rcMember.validate('change')
        this.executeFunctions('change')
      })
    },
    dialogClose () {
      this.$refs.tree.$children[0].node.parent.childNodes[0].expanded = false
      this.memberDialog.dialogVisible = false
    },
    getPrincipal () {
      this.$axios.get(`/auth-api/organization/getUserTree`).then(res => {
        let data = res.data || []
        this.memberData = this.recursion(data)
        this.firstLevelId = this.memberData[0] ? [this.memberData[0].id] : []
        this.$forceUpdate()
      })
    },
    recursion (arr) {
      arr.forEach(n => {
        if (n.type === 'user') {
          n.flag = false
          let index = this.initData.indexOf(n.name)
          if (index !== -1) {
            n.flag = true
            this.memberSelectedList[index] = {'id': n.id, 'name': n.name, 'type': n.type}
          }
        }
        if (n.children.length) {
          this.recursion(n.children)
        }
      })
      return arr
    },
    getValue () {
      if (this.disabled || this.component.properties.readonly) {
        return this.value
      } else {
        let str = ''
        this.memberSelectedList.forEach(n => {
          str += n.name + '、'
        })
        if (str) {
          str = str.substring(0, str.length - 1)
        }
        return str
      }
    },
    removeNode (id, arr) {
      arr.forEach(n => {
        if (n.type === 'user' && n.id === id) {
          n.flag = false
        } else if (n.children.length) {
          this.removeNode(id, n.children)
        }
      })
    }
  },
  watch: {
    'memberDialog.filterText' (val) {
      this.$refs.tree.filter(val)
    },
    'value' (value) {
      if (value && typeof value === 'string') {
        this.initData = value.split('、')
        if (this.memberData) {
          this.memberData = this.recursion(this.memberData)
        }
      } else {
        this.initData = []
        this.memberSelectedList = []
        this.recursion(this.memberData)
      }
    }
  }
}
</script>

<style lang="scss">
  .rc-member-run {
    height: 28px;
    line-height: 28px;
    .el-form-item.hidden{
      .el-form-item__label{
        display: none;
      }
    }

    .rc-member-content {
      .selected {
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .choiceMember {
          color: var(--primary, #54ABF1);
          margin-right: 8px;
        }

        .readonly {
          color: #ddd;
        }

        .memberName {
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .readonly {
        color: #2A2929;

        .choiceMember {
          text-decoration: none;
        }
      }
      &.is-error{
        .selected{
          .choiceMember {
            color: #F56C6C;
          }
        }
        .el-form-item__error{
          display: none;
        }
      }
    }
  }

  .rc-member-run.to-top {
    height: 56px;
    line-height: 28px;

    .rc-member-content {
      .selected {
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .choiceMember {
          color: #54ABF1;
          margin-right: 8px;
        }

        .readonly {
          color: #ddd;
        }

        .memberName {
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .readonly {
        color: #2A2929;

        .choiceMember {
          text-decoration: none;
        }
      }
      &.is-error{
        .selected{
          .choiceMember {
            color: #F56C6C;
          }
        }
        .el-form-item__error{
          display: none;
        }
      }
    }
  }
  /*append-to-body。dialog定位在body上*/
  .member-dialog {
    .el-dialog__body {
      padding: 12px 10px 0;

      .member-dialog-content {
        display: flex;
        border-radius: 5px;
        width: 100%;
        height: 366px;
        box-sizing: border-box;
        padding: 13px 0;
        border: 1px solid #dddddd;

        .left {
          width: 50%;
          height: 100%;
          padding: 0 13px;
          .el-tree{
            height: 310px;
            overflow: auto;
          }
          .el-tree-node__content{
            font-size: 14px;
            >.el-tree-node__expand-icon {
              padding: 5px;
            }
            .expanded{
              transform: rotate(0deg)
            }
            .expanded:before{
              content: "\e781";
            }
          }
        }

        .right {
          width: 50%;
          height: 100%;
          border-left: 1px solid #ddd;
          .title {
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 12px;
          }

          .person {
            height: 310px;
            overflow-y: auto;
            p {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 26px;
              line-height: 26px;
              padding: 0 13px;

              .remove-select {
                color: #CBCBCB;
              }
              .remove-select:active {
                color: red;
              }
            }

            p:nth-child(odd) {
              background-color: var(--light-9, #ECF5FB);
            }

            p:hover {
              .remove-select {
                color: #fb9391;
              }
            }
            p:active {
              .remove-select {
                color: red;
              }
            }
          }
        }

        .custom-tree-node {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-icon-check{
            color: var(--primary, #54ABF1);
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 15px;

      .dialog-footer {
        text-align: center;

        .el-button {
          width: 80px;
        }

        .el-button + .el-button {
          margin-left: 50px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-member.vue